import { render, staticRenderFns } from "./EmbedCodes.vue?vue&type=template&id=e487902a&scoped=true"
import script from "./EmbedCodes.vue?vue&type=script&lang=js"
export * from "./EmbedCodes.vue?vue&type=script&lang=js"
import style0 from "./EmbedCodes.vue?vue&type=style&index=0&id=e487902a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e487902a",
  null
  
)

export default component.exports